

define(['angular', 'jquery', 'components/xo-beaver/dist/logger', './fpti', './button', 'xo-models/src/auth'], function (angular, $) {
    angular.module('tracking.listener', ['beaver', 'tracking.fpti', 'button.tracking']).run(function ($rootScope, $logger, $CalDataModel, $AuthModel, $fpti, $fptiError, $FptiConstants, $ButtonTrackingService, $timeout, $FptiBuilder, $meta) {

        function logTransition(state) {
            return !(state.trackingData && state.trackingData.suppressTransitionLog);
        }

        function logStateExit(state) {
            return state.trackingData && state.trackingData.trackStateExit;
        }

        /*
         * Triggers pa.js recordClick with custom parameters
         */
        function fptiCustomRecordClick(route, customData) {
            var analyticsInstance, fptiData, pxpData, fptiDataObj;
            var PAYPAL = window.PAYPAL;

            if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
                PAYPAL.core = PAYPAL.core || {};

                analyticsInstance = new PAYPAL.analytics.Analytics();

                fptiData = new $FptiBuilder({
                    trackingData: route.trackingData,
                    isInContext: $rootScope.miniBrowser
                    // ... Other flow data pass-in here to resolve page qualifier
                }).build();

                // Add the pxp data in fptiData as custom Attributes
                fptiDataObj = fptiData._dataObj;
                if (fptiDataObj) {
                    pxpData = {
                        qc: fptiDataObj.qc,
                        qt: fptiDataObj.qt,
                        xe: fptiDataObj.xe,
                        xt: fptiDataObj.xt
                    };
                    $.extend(customData, pxpData);
                }

                analyticsInstance.setRequestData(customData);

                analyticsInstance.recordClick();
            }
        }

        $rootScope.$on('trackInput', function (event, trackInput) {
            if (!trackInput) {
                return;
            }
            var customData = {
                link: trackInput.transition,
                page: trackInput.page
            };

            fptiCustomRecordClick(trackInput.currentRoute, customData);
        });

        $rootScope.$on('trackSubmit', function (event, trackSubmit) {
            if (!trackSubmit) {
                return;
            }
            var currentRoute = trackSubmit.currentRoute;
            var routeName = currentRoute ? currentRoute.name : 'noRoute';

            $logger.info('track_submit', {
                route_name: routeName
                // ID stuff here later
            });

            if (logTransition(currentRoute)) {
                routeName = routeName.replace(/\./g, '_');
                var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
                var transition = trackSubmit.transition || state;

                $logger.info(routeName + '_exit', {
                    fptiState: state,
                    fptiTransition: transition
                });
            }

            var errors = trackSubmit.errors;
            if (angular.isArray(errors)) {
                errors.forEach(function (err) {
                    $logger.debug('track_submit_error', err);
                    if ($fpti) {
                        $fpti.setupDataString(currentRoute, new $fptiError({
                            type: 'fieldError',
                            field: err.fieldName,
                            code: err.errorMessage
                        }));
                    }
                });

                if (errors.length) {
                    $logger.flush(true);
                }
            }
        });

        $rootScope.$on('unhandled_error', function (event, exception) {
            if ($fpti) {
                $fpti.setupDataString(exception.currentRoute, new $fptiError({
                    type: 'pageError',
                    message: exception.message,
                    code: exception.cause
                }));
            }
        });

        $rootScope.$on('trackLink', function (event, trackLink) {
            if (!trackLink) {
                return;
            }

            var currentRoute = trackLink.currentRoute;
            var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
            var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;

            $logger.info(routeName + '_exit', {
                fptiState: state,
                fptiTransition: trackLink.transition
            });
        });

        $rootScope.$on('$transition', function (event, data) {

            $timeout(function () {
                if ($fpti) {

                    var $auth = $AuthModel.instance();

                    var fptiData = $fpti.setupDataString(data.toState, null, {
                        transition_time: data.duration,
                        dc: $meta.dc,
                        az: $meta.az,
                        cust: $auth.buyer_id || ''
                    });

                    // Fire and forget button tracking beacon.
                    $ButtonTrackingService.fireBeacon(fptiData);
                }
            });
        });

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {

            var from = fromState.name.replace(/\./g, '_');
            var to = toState.name.replace(/\./g, '_');
            if (from && logTransition(fromState) && logStateExit(fromState)) {
                var trackingData = fromState.trackingData && fromState.trackingData || {};
                $logger.info(from + '_exit', { fptiState: trackingData.fptiState || from, fptiTransition: trackingData.fptiState || from });
            }

            $logger.info('state_change', {
                from: from || 'start',
                to: to || 'end'
            });

            $logger.flush(true);

            // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
            if (toState.template) {
                $CalDataModel.generateMetaIds();
            }

            $rootScope.currentState = to;

            if (to && logTransition(toState)) {
                $logger.info(to + '_enter', { fptiState: toState.trackingData && toState.trackingData.fptiState || to });
            }
        });

        $rootScope.$on('page_loaded', function (event, from, to) {
            if (from !== 'checkout_init') {
                return;
            }
            var key = $FptiConstants.stateName[to] || 'review';
            var landing_page = $FptiConstants.landing_page[key];
            $logger.info('landing_page', { fpti_landing_page: landing_page });
        });

        $rootScope.$on('page_reloaded', function () {
            $logger.flush(true);
            $CalDataModel.generateMetaIds();
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            var to = toState.name.replace(/\./g, '_');
            if (toState.hasResolver && to) {
                $logger.info(to + '_load');
            } else if (to) {
                $logger.info(to + '_rendering');
            }
        });

        $rootScope.$on('addrDiff', function (event, addrDiff) {
            if (!addrDiff) {
                return;
            }

            $logger.info('is_ship_addr_diff', addrDiff);
        });

        function getHash(url) {
            if (!url || !~url.indexOf('#')) {
                // eslint-disable-line no-bitwise
                return;
            }

            url = url.split('#');
            return url[url.length - 1];
        }

        var oldHash = window.location.hash;

        window.addEventListener('hashchange', function (event) {
            $logger.info('hashchange', {
                from: getHash(event.oldURL || oldHash),
                to: getHash(event.newURL || window.location.hash)
            });
            oldHash = window.location.hash;
        });

        $(document).on('click', function (event) {
            if (event && event.target && event.target.tagName) {
                var name = event.target.tagName.toLowerCase();

                if (event.target.id) {
                    name += '#' + event.target.id;
                } else if (event.target.attributes && event.target.attributes['ng-model']) {
                    name += ':' + event.target.attributes['ng-model'].value;
                } else if (event.target.className) {
                    name += '.' + event.target.className.split(' ').join('.');
                }

                $logger.info('click', {
                    el: name
                });
            }
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-tracking/dist/listener.js
 ** module id = 166
 ** module chunks = 1
 **/